import cx from 'clsx';
import React from 'react';

import useTranslation from '@hooks/useTranslation';

import { selectAppRtl } from '@store/useAppStore';

import style from './style.module.scss';

interface IProps {
  checked: boolean;
  id: string;
  value?: string | number;
  label: string;
  customCls?: string;
  readOnly?: boolean;
  disabled?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

const RadioButton: React.FC<IProps> = ({
  checked,
  id,
  value,
  label,
  customCls,
  readOnly,
  disabled,
  onChange,
}) => {
  const { t } = useTranslation();
  const rtl = selectAppRtl();
  return (
    <div className={cx(style.radioButton, customCls)}>
      <label
        className={cx(style.radioLabel, { [style.radioLabelRtl]: rtl, [style.radioLabelDisabled]: disabled })}
      >
        {t(label)}
        <input
          className={style.radioInput}
          id={id}
          onChange={onChange}
          value={value}
          type="radio"
          checked={checked}
          readOnly={readOnly}
          disabled={disabled}
        />
        <span className={cx(style.checkmark, { [style.checkmarkRtl]: rtl })} />
      </label>
    </div>
  );
};

export default RadioButton;
